import {LocaleEnum} from '../types/locale';

export const getWholePart = (number: number): number | typeof NaN => Math.trunc(number);

/*
 * Extracts the decimal part of a given number by using the modulus operator (%).
 * It returns the remainder when the number is divided by 1.
 * Precision Warning: not always precise thousandth(+) due to floating-point arithmetic limitations in JavaScript. e.g., 10.99 returns 0.9900000000000002
 * */
export const getDecimalPart = (number: number): number => number % 1;

export const getPriceDecimalPart = (locale: LocaleEnum, num: number, decimalParts: number = 2): number | typeof NaN =>
  parseInt(getPriceParts(locale, num, decimalParts).decimalPart);

export function getPriceParts(
  locale: LocaleEnum,
  price: number,
  decimalPlaces: number = 2
): {
  wholePart: string;
  decimalPart: string;
  decimalSeparator: string;
} {
  const referenceIntlFormattedPrice = new Intl.NumberFormat(locale, {
    style: 'decimal',
    maximumFractionDigits: 1,
    minimumFractionDigits: 1
  }).format(1.1);
  const decimalSeparator = referenceIntlFormattedPrice.charAt(1);

  const intlFormattedPrice = new Intl.NumberFormat(locale, {
    style: 'decimal',
    maximumFractionDigits: decimalPlaces,
    minimumFractionDigits: decimalPlaces
  })
    .format(price)
    .trim();

  const [wholePart, decimalPart = '0'] = intlFormattedPrice.split(decimalSeparator);

  return {
    wholePart: wholePart,
    decimalPart: decimalPart,
    decimalSeparator: decimalSeparator
  };
}
